import { PRODUCT_SCOPE } from '../../domain/seasonalLaunch';

const SCOPE = {
  PRIMARY: PRODUCT_SCOPE.PRIMARY_LAUNCH,
  SUPPORTING: PRODUCT_SCOPE.SUPPORTING_COMPARISON,
};

const LAUNCH_IMAGE_BASE = '/images/launches/eskimo-2026-27';

function launchImg(file, alt, width = 900, height = 900, fit = 'contain') {
  return {
    src: `${LAUNCH_IMAGE_BASE}/${file}`,
    alt,
    width,
    height,
    fit,
  };
}

const PRODUCT_MEDIA = {
  'e-connect-shelter-link': {
    image: launchImg('eskimo-econnect-shelter-link.webp', 'Eskimo E-Connect Shelter Link'),
  },
  'e-hauler-folding-cargo-rack': {
    image: launchImg('eskimo-ehauler-folding-cargo-rack.webp', 'Eskimo E-Hauler Folding Cargo Rack'),
  },
  'e-hauler-xl-sled': {
    image: launchImg('eskimo-ehauler-xl-sled.webp', 'Eskimo E-Hauler XL Sled'),
  },
  'e-hauler-pulk-system': {
    image: launchImg('eskimo-ehauler-pulk-system.webp', 'Eskimo E-Hauler Pulk System'),
  },
  'e-hub-waste-bag-holder': {
    image: launchImg('eskimo-ehub-waste-bag-holder.webp', 'Eskimo E-Hub Waste Bag Holder'),
  },
  'e-hub-triple-rod-holder': {
    image: launchImg('eskimo-ehub-triple-rod-holder.webp', 'Eskimo E-Hub Triple Rod Holder'),
  },
  'flex-jacket': {
    image: launchImg('eskimo-flex-jacket.webp', 'Eskimo Flex Jacket'),
  },
  'flex-bibs': {
    image: launchImg('eskimo-flex-bibs.webp', 'Eskimo Flex Bibs'),
  },
  'fatfish-450i': {
    image: launchImg('eskimo-fatfish-450i.webp', 'Eskimo FatFish 450i ice fishing shelter'),
    lineupRole: "Alex's Pick",
    lineupMetric: '75 sq. ft.',
  },
  'fatfish-650i': {
    image: launchImg('eskimo-fatfish-650i.webp', 'Eskimo FatFish 650i ice fishing shelter'),
    lineupRole: 'Bigger groups',
    lineupMetric: '94 sq. ft.',
  },
  'fatfish-850i': {
    image: launchImg('eskimo-fatfish-850i.webp', 'Eskimo FatFish 850i ice fishing shelter'),
    lineupRole: 'Large groups / basecamp',
    lineupMetric: '114 sq. ft.',
  },
  'quickfish-4hd': {
    image: launchImg('eskimo-quickfish-4hd.webp', 'Eskimo QuickFish 4HD ice fishing shelter'),
    lineupRole: 'Portable day shelter',
    lineupMetric: '50 lb.',
  },
  'standard-tow-hitch': {
    image: launchImg('eskimo-standard-tow-hitch.webp', 'Eskimo Standard Tow Hitch'),
  },
  'aluminum-xl-tripod-chair': {
    image: launchImg('eskimo-aluminum-xl-tripod-chair.webp', 'Eskimo Aluminum XL Tripod Chair'),
  },
  'outpost-wool-hoodie': {
    image: launchImg('eskimo-outpost-wool-hoodie.webp', 'Eskimo Outpost Wool Hoodie'),
  },
  'traverse-wool-jacket': {
    image: launchImg('eskimo-traverse-wool-jacket.webp', 'Eskimo Traverse Wool Jacket'),
  },
  'flag-hoodie': {
    image: launchImg('eskimo-flag-hoodie.webp', 'Eskimo Flag Hoodie'),
  },
  'abyss-hoodie': {
    image: launchImg('eskimo-abyss-hoodie.webp', 'Eskimo Abyss Hoodie'),
  },
  'dipped-gloves': {
    image: launchImg('eskimo-dipped-gloves.webp', 'Eskimo Dipped Gloves'),
  },
  'outbreak-450xdp': {
    image: launchImg('eskimo-outbreak-450xdp.webp', 'Eskimo Outbreak 450XDP ice fishing shelter'),
  },
  'outbreak-650xdp': {
    image: launchImg('eskimo-outbreak-650xdp.webp', 'Eskimo Outbreak 650XDP ice fishing shelter'),
  },
  'outbreak-850xdp': {
    image: launchImg('eskimo-outbreak-850xdp.webp', 'Eskimo Outbreak 850XDP ice fishing shelter'),
  },
  'e-hub-triple-mount': {
    image: launchImg('eskimo-ehub-triple-mount.webp', 'Eskimo E-Hub Triple Mount'),
  },
};

const PRODUCT_INDEX = {
  'fatfish-450i': {
    indexTakeaway:
      "My day-shack pick. It's only $50 more and 2.5 lb. heavier than the QuickFish 4HD, but gives you 15 more sq. ft., larger windows and more storage.",
    indexBadge: "ALEX'S PICK",
    indexDetailHref: '#featured-decision',
    indexDetailLabel: 'Read the QuickFish comparison',
  },
  'quickfish-4hd': {
    indexTakeaway:
      'The lighter, simpler option at 50 lb. with 60 sq. ft. of fishable area. Best if minimizing weight matters more than maximizing room.',
    indexDetailHref: '#featured-decision',
    indexDetailLabel: 'Read the FatFish comparison',
  },
  'fatfish-650i': {
    indexTakeaway:
      'The FatFish sweet spot for bigger groups, with 94 sq. ft. of fishable area without moving all the way to the 850 size.',
    indexDetailHref: '#shelters',
    indexDetailLabel: 'See my take',
  },
  'fatfish-850i': {
    indexTakeaway:
      "114 sq. ft. and the FatFish I'd look at for large groups, longer days or basecamp-style setups.",
    indexDetailHref: '#shelters',
    indexDetailLabel: 'See my take',
  },
  'e-connect-shelter-link': {
    indexTakeaway:
      'One of the coolest ideas in the launch. Connect compatible shelters and use one as your fishing room and another as a sleeping or living space.',
    indexDetailHref: '#e-connect',
    indexDetailLabel: 'See how E-Connect works',
  },
  'e-hauler-folding-cargo-rack': {
    indexTakeaway:
      'Gets your auger, shelter or other bulky gear above the sled so you can actually use the storage space underneath.',
    indexDetailHref: '#e-hauler',
    indexDetailLabel: 'See the E-Hauler setups',
  },
  'e-hauler-pulk-system': {
    indexTakeaway:
      "The E-Hauler piece I'd pay attention to if you walk out. The waist harness frees your hands and the rigid poles help control the sled on slopes.",
    indexDetailHref: '#e-hauler',
    indexDetailLabel: 'See the E-Hauler setups',
  },
  'e-hauler-xl-sled': {
    indexTakeaway:
      'A larger 64 x 36-inch sled that becomes the foundation for the rack, Pulk System or machine-tow setup.',
    indexDetailHref: '#e-hauler',
    indexDetailLabel: 'See the E-Hauler setups',
  },
  'standard-tow-hitch': {
    indexTakeaway:
      'The machine-towing option for pulling a compatible sled behind a snowmobile or ATV instead of walking it with the Pulk System.',
    indexDetailHref: '#e-hauler',
    indexDetailLabel: 'See the E-Hauler setups',
  },
  'e-hub-triple-rod-holder': {
    indexTakeaway:
      "Three rods from one E-Hub mounting location, with the ability to expand the system further using Eskimo's existing Triple Mount.",
    indexDetailHref: '#e-hub',
    indexDetailLabel: 'See my take',
  },
  'e-hub-waste-bag-holder': {
    indexTakeaway:
      'Simple but useful. It mounts to E-Hub and holds a common shopping bag open for trash inside the shelter.',
    indexDetailHref: '#e-hub',
    indexDetailLabel: 'See my take',
  },
  'aluminum-xl-tripod-chair': {
    indexTakeaway:
      'A larger tripod chair that still weighs only 4 lb. and carries a 400-lb. rated capacity.',
    indexDetailHref: '#aluminum-xl-tripod-chair',
    indexDetailLabel: 'See my take',
  },
  'flex-jacket': {
    indexTakeaway:
      'The biggest apparel launch. Flotation, 10K/10K weather protection and stretch construction aimed at being easier to move and layer in.',
    indexDetailHref: '#flex',
    indexDetailLabel: 'See the Flex breakdown',
  },
  'flex-bibs': {
    indexTakeaway:
      'The matching Flex bibs add flotation, stretch, full-leg access and reinforced knee protection without the bulky feel of a traditional heavy suit.',
    indexDetailHref: '#flex',
    indexDetailLabel: 'See the Flex breakdown',
  },
  'traverse-wool-jacket': {
    indexTakeaway:
      'A warm wool-blend jacket with 80gm Thinsulate and a 5K/5K membrane. Weather-resistant, but not a fully waterproof shell.',
    indexDetailHref: '#apparel',
    indexDetailLabel: 'See my take',
  },
  'outpost-wool-hoodie': {
    indexTakeaway:
      'A premium wool-blend midlayer that makes sense both on the ice and as an everyday cold-weather hoodie.',
    indexDetailHref: '#apparel',
    indexDetailLabel: 'See my take',
  },
  'dipped-gloves': {
    indexTakeaway:
      'A simple waterproof nitrile-dipped cold-weather glove with thermal lining and a textured grip.',
    indexDetailHref: '#apparel',
    indexDetailLabel: 'See my take',
  },
  'flag-hoodie': {
    indexTakeaway: 'A heavyweight 380gm sweatshirt-fleece hoodie with Eskimo Flag styling.',
  },
  'abyss-hoodie': {
    indexTakeaway:
      'The other new heavyweight 380gm lifestyle hoodie, with Abyss styling instead of the Flag design.',
  },
};

function applyLaunchMedia(launch) {
  return {
    ...launch,
    products: launch.products.map((product) => ({
      ...product,
      ...(PRODUCT_MEDIA[product.id] || {}),
      ...(PRODUCT_INDEX[product.id] || {}),
    })),
  };
}

export const ESKIMO_2026_27_LAUNCH = applyLaunchMedia({
  id: 'eskimo-2026-27',
  slug: 'eskimo-new-gear-2026-27',
  sectionBasePath: '/ice-fishing',
  brand: 'Eskimo',
  launchSeason: '2026-27',
  authorName: 'Alex Timm',
  publishedDate: '2026-09-11',
  pageTitle: "New Eskimo Ice Fishing Gear for 2026-27: Alex Timm's Complete Breakdown",
  seoTitle: 'Eskimo 2026-27 New Ice Fishing Gear: Full Breakdown',
  metaDescription:
    "Alex Timm breaks down Eskimo's new 2026-27 shelters, E-Hauler gear, E-Hub accessories and apparel, including key differences, specs and buying links.",
  breadcrumbs: [
    { label: 'Home', path: '/' },
    { label: 'Ice Fishing' },
    { label: 'Eskimo 2026-27 New Gear' },
  ],
  intro: [
    "Eskimo has a big 2026-27 launch that includes new FatFish shelters, a new QuickFish size, a way to connect compatible hub shelters, an expanded E-Hauler and E-Hub accessory system, a new Flex flotation suit, and several new apparel pieces.",
    "I went to Eskimo's headquarters to see the gear in person and walk through what actually changed. This was not a sponsored video. Below is the gear from the video, the important specs, my take on what matters, and current buying links.",
  ],
  independenceDisclosure:
    'Independent gear coverage. I buy my own fishing gear. No free products, paid reviews, or money from fishing brands.',
  affiliateDisclosure:
    'Some links on this page are affiliate links. If you buy through them, I may earn a commission at no extra cost to you. It helps support independent gear coverage.',
  videoId: null,
  videoUrl: null,
  videoTitle: 'Eskimo 2026-27 new ice fishing gear breakdown',
  visual: {
    brandAccent: '#CE181E',
    heroTitle: 'New Eskimo Ice Fishing Gear for 2026-27',
    guideLabel: 'INDEPENDENT GUIDE TO',
    seasonLabel: '2026-27 NEW GEAR',
    updatedLabel: 'Updated September 2026',
    productCountLabel: '19 New Products',
    logo: launchImg('eskimo-logo.webp', 'Eskimo Ice Fishing Gear', 800, 347, 'contain'),
    heroImage: launchImg(
      'eskimo-hero-fatfish-450i.webp',
      'Eskimo FatFish 450i set up on the ice',
      1400,
      1400,
      'cover'
    ),
    eConnectImage: launchImg(
      'eskimo-econnect-connected.webp',
      'Two Eskimo shelters joined by the E-Connect Shelter Link',
      1400,
      1400,
      'cover'
    ),
    flexImage: launchImg(
      'eskimo-flex-suit-worn.webp',
      'Angler wearing the Eskimo Flex jacket and bibs',
      1200,
      1200,
      'cover'
    ),
  },
  jumpNav: [
    { href: '#whats-new', label: "What's New" },
    { href: '#shelters', label: 'Shelters' },
    { href: '#shelter-comparison', label: 'Shelter Comparison' },
    { href: '#e-hauler', label: 'E-Hauler' },
    { href: '#e-hub', label: 'E-Hub' },
    { href: '#apparel', label: 'Apparel' },
    { href: '#all-new-gear', label: 'All New Gear' },
  ],
  launchIndex: {
    eyebrow: '2026-27 PRODUCT LINEUP',
    heading: "What's New From Eskimo for 2026-27?",
    intro:
      "Eskimo has 19 new products for the 2026-27 season. If you just want to see what's new, start here. I've included the launch price, the one thing I think matters most, and a direct path to check current pricing. Keep scrolling for my deeper comparisons and take on which products stand out.",
    countLabel: '19 NEW PRODUCTS',
    groups: [
      {
        id: 'shelters',
        label: 'Shelters',
        countLabel: '4 Shelters',
        productIds: ['fatfish-450i', 'quickfish-4hd', 'fatfish-650i', 'fatfish-850i'],
      },
      {
        id: 'shelter-system',
        label: 'Shelter System',
        countLabel: '1 Shelter Connector',
        productIds: ['e-connect-shelter-link'],
      },
      {
        id: 'hauling',
        label: 'Hauling',
        countLabel: '4 Hauling Products',
        productIds: [
          'e-hauler-folding-cargo-rack',
          'e-hauler-pulk-system',
          'e-hauler-xl-sled',
          'standard-tow-hitch',
        ],
      },
      {
        id: 'e-hub',
        label: 'E-Hub',
        countLabel: '2 E-Hub Accessories',
        productIds: ['e-hub-triple-rod-holder', 'e-hub-waste-bag-holder'],
      },
      {
        id: 'seating',
        label: 'Seating',
        countLabel: '1 Chair',
        productIds: ['aluminum-xl-tripod-chair'],
      },
      {
        id: 'apparel',
        label: 'Apparel',
        countLabel: '7 Apparel Products',
        productIds: [
          'flex-jacket',
          'flex-bibs',
          'traverse-wool-jacket',
          'outpost-wool-hoodie',
          'dipped-gloves',
          'flag-hoodie',
          'abyss-hoodie',
        ],
      },
    ],
    transition: {
      eyebrow: "ALEX'S TAKE",
      heading: 'Which New Products Actually Stand Out?',
      copy:
        "That's the full 2026-27 lineup. Now let's get into the pieces I think matter most, where the real differences are, and what I'd actually choose.",
    },
  },
  shelterSection: {
    heading: 'New Eskimo Shelters for 2026-27',
    intro:
      'The shelter lineup is where the most important buying decisions are. The new QuickFish 4HD targets portability, while the three FatFish models add more space and interior features without moving all the way into Outbreak XDP pricing.',
    comparisonRows: [
      { id: 'launch-price', label: 'Launch price' },
      { id: 'capacity', label: 'Capacity' },
      { id: 'fishable-area', label: 'Fishable area' },
      { id: 'weight', label: 'Weight' },
      { id: 'pack-length', label: 'Pack length' },
      { id: 'fabric', label: 'Fabric' },
      { id: 'doors', label: 'Doors' },
      { id: 'windows', label: 'Windows' },
      { id: 'gear-nets', label: 'Gear nets' },
      { id: 'best-fit', label: 'Best fit' },
    ],
    productIds: ['quickfish-4hd', 'fatfish-450i', 'fatfish-650i', 'fatfish-850i'],
  },
  featuredDecision: {
    heading: 'QuickFish 4HD vs. FatFish 450i: Which Would I Buy?',
    pickProductId: 'fatfish-450i',
    pickLabel: "Alex's Pick",
    copy: [
      "If I were choosing between the QuickFish 4HD and FatFish 450i for a day shelter, I'd spend the extra $50 for the FatFish 450i.",
      'It is only 2.5 pounds heavier, but you gain 15 square feet of fishable area, larger windows, two overhead gear nets and a shorter 4\'10" pack length.',
      'The QuickFish still makes sense if keeping the shelter as simple and light as possible is the priority. For me, the FatFish 450i gives up very little portability for a meaningful jump in usable shelter.',
    ],
    deltaHeading: 'WHAT $50 MORE GETS YOU',
    deltaLead: 'FatFish 450i vs QuickFish 4HD:',
    deltas: [
      '+$50',
      '+2.5 lb.',
      '+15 sq. ft.',
      '7 windows vs 4',
      '2 gear nets vs 0',
      '4\'10" pack length vs 5\'6"',
    ],
    productIds: ['quickfish-4hd', 'fatfish-450i'],
    placement: 'alex_pick',
  },
  outbreakComparison: {
    heading: 'FatFish vs. Outbreak XDP: What\'s the Difference?',
    intro:
      'The simple way to think about the lineup is FatFish for value and Outbreak XDP for the more premium shelter package.',
    groups: [
      {
        heading: '450 size',
        sizeLabel: '450 SERIES',
        leftId: 'fatfish-450i',
        rightId: 'outbreak-450xdp',
        priceDelta: '+$80',
        premiumGets: ['StormShield insulation', 'heater duct ports', 'propane-line port'],
      },
      {
        heading: '650 size',
        sizeLabel: '650 SERIES',
        leftId: 'fatfish-650i',
        rightId: 'outbreak-650xdp',
        priceDelta: '+$80',
        premiumGets: [
          'StormShield insulation',
          'additional premium heating and ventilation features',
        ],
      },
      {
        heading: '850 size',
        sizeLabel: '850 SERIES',
        leftId: 'fatfish-850i',
        rightId: 'outbreak-850xdp',
        priceDelta: '+$100',
        premiumGets: ['StormShield insulation', 'two No-Trip Doors', '120 sq. ft. vs 114 sq. ft.'],
      },
    ],
    decisionCopy: [
      'Buy FatFish if you want most of the layout and convenience at a lower price and lower weight.',
      'Buy Outbreak XDP if premium insulation, external-heater compatibility and the additional premium shelter features are worth the extra cost to you.',
    ],
    placement: 'outbreak_comparison',
  },
  eHauler: {
    heading: 'Build an E-Hauler Setup',
    paths: [
      {
        id: 'walkout',
        kicker: 'PATH 1',
        heading: 'Walking Out',
        result: 'HANDS-FREE WALKOUT SETUP',
        formula: 'Sled + Folding Cargo Rack + Pulk System',
        copy:
          'The Folding Cargo Rack gets long gear up and out of the tub. The Pulk System moves the pulling load to a waist harness and uses rigid poles to keep the sled tracking behind you instead of running into your legs.',
        visualProductIds: [
          'e-hauler-xl-sled',
          'e-hauler-folding-cargo-rack',
          'e-hauler-pulk-system',
        ],
        productIds: ['e-hauler-folding-cargo-rack', 'e-hauler-pulk-system'],
        placement: 'ehauler_walkout',
      },
      {
        id: 'towing',
        kicker: 'PATH 2',
        heading: 'Snowmobile / ATV',
        result: 'MACHINE-TOW SETUP',
        formula: 'XL Sled + Folding Cargo Rack + Standard Tow Hitch',
        copy: '',
        visualProductIds: ['e-hauler-xl-sled', 'e-hauler-folding-cargo-rack', 'standard-tow-hitch'],
        productIds: ['e-hauler-xl-sled', 'standard-tow-hitch'],
        placement: 'ehauler_towing',
      },
    ],
  },
  eHub: {
    heading: 'New E-Hub Accessories',
    productIds: ['e-hub-triple-rod-holder', 'e-hub-waste-bag-holder'],
    systemPoints: [
      { value: '1', label: 'BASE' },
      { value: '3', label: 'MOUNTING POINTS' },
      { value: 'UP TO 3', label: 'TRIPLE ROD HOLDERS' },
    ],
    crossSell: {
      productId: 'e-hub-triple-mount',
      copy:
        "Want to expand the setup further? Eskimo's E-Hub Triple Mount creates three E-Hub mounting points from one base. Pairing it with Triple Rod Holders opens up much larger rod-storage configurations.",
      placement: 'ehub_cross_sell',
    },
  },
  apparel: {
    heading: 'New Eskimo Apparel for 2026-27',
    flex: {
      heading: 'Flex Jacket + Bibs: The Big Apparel Launch',
      intro:
        'The important idea behind the Flex suit is versatility and mobility rather than simply building the bulkiest or warmest ice suit possible. It combines flotation, waterproof protection and flexible softshell construction for anglers moving between open ice, shelters, wheelhouses and changing temperatures.',
      highlights: ['10K / 10K', 'UPLYFT FLOTATION', '4-WAY STRETCH', '270gm FLEECE'],
      sharedSpecs: [
        'Uplyft Breathable Flotation',
        '10K/10K waterproof/breathable membrane',
        'fully taped seams',
        'DWR',
        '92% polyester / 8% spandex softshell',
        '4-way stretch',
        '270gm low-bulk fleece',
      ],
      productIds: ['flex-jacket', 'flex-bibs'],
      placement: 'flex_suit',
    },
    traverseHighlights: ['5K / 5K membrane', '80gm Thinsulate', 'Wool blend'],
    hoodiePair: {
      sharedDescription:
        'Both are heavyweight 380gm sweatshirt-fleece hoodies with kangaroo pockets, three-piece hoods and rib-knit cuffs and waist. The main difference is styling.',
      productIds: ['flag-hoodie', 'abyss-hoodie'],
    },
    otherProductIds: ['traverse-wool-jacket', 'outpost-wool-hoodie', 'dipped-gloves'],
  },
  faqs: [
    {
      question: 'Which would Alex buy, the QuickFish 4HD or FatFish 450i?',
      answer:
        "If I were buying a day shelter, I'd choose the FatFish 450i. At launch pricing it is only $50 more and 2.5 pounds heavier, but you gain 15 square feet of fishable area, larger windows, more interior storage and a shorter pack length.",
    },
    {
      question: "What's the difference between FatFish and Outbreak XDP?",
      answer:
        'FatFish is the value-oriented line. The comparable Outbreak XDP shelters use Eskimo\'s premium StormShield insulation and add features such as heat-source ports. The 850XDP also has two No-Trip Doors and 120 square feet compared with one No-Trip Door plus a rear D-door and 114 square feet in the FatFish 850i.',
    },
    {
      question: 'Which shelters work with the E-Connect Shelter Link?',
      answer:
        'Eskimo specifies compatibility with FatFish and Outbreak XDP shelters equipped with a No-Trip Door.',
    },
    {
      question: 'Does the Eskimo Flex suit have flotation?',
      answer: "Yes. Both the Flex Jacket and Flex Bibs use Eskimo's Uplyft Breathable Flotation.",
    },
    {
      question: 'Is the Traverse Wool Jacket waterproof?',
      answer:
        'It has a 5K/5K waterproof/breathable membrane and DWR, but Eskimo lists it as not fully waterproof because the seams are not taped. Treat it as a warm, weather-resistant jacket rather than a fully waterproof shell.',
    },
  ],
  snapshot: {
    heading: '2026-27 Eskimo Launch Snapshot',
    copy:
      "Prices shown on this page are Eskimo's listed launch prices checked September 11, 2026. Retail pricing, availability and product status can change. Use the current-price links above for current buying options.",
    checkedOn: '2026-09-11',
  },
  shareAsset: {
    enabled: true,
    shortUrl: 'https://at.fish/Eskimo26',
    displayUrl: 'at.fish/Eskimo26',
    headline: 'ALL THE NEW ESKIMO GEAR',
    supportingText: 'Specs, comparisons, my take & current buying links',
    filename: 'angler-built-eskimo-2026-27-qr.png',
    barColor: '#CE181E',
    bottomBarColor: '#111111',
  },
  products: [
    {
      id: 'e-connect-shelter-link',
      name: 'E-Connect Shelter Link',
      brand: 'Eskimo',
      category: 'shelter-accessory',
      scope: SCOPE.PRIMARY,
      launchPrice: 79.99,
      affiliateUrl: 'https://at.fish/EConnectShelterLink',
      description:
        "The E-Connect Shelter Link joins the No-Trip Door entrances of compatible FatFish and Outbreak XDP shelters to create an enclosed hallway between them. It uses the shelters' existing door poles and hook-and-loop attachment points.",
      editorialNote:
        'The most interesting use is ice camping: use one shelter as your fishing room and the second as a dedicated sleeping room.',
      compatibilityNote:
        'Compatible with FatFish and Outbreak XDP series shelters equipped with a No-Trip Door.',
      sectionHeading: 'Turn Two Shelters Into One Basecamp',
      defaultPlacement: 'product_detail',
    },
    {
      id: 'e-hauler-folding-cargo-rack',
      name: 'E-Hauler Folding Cargo Rack',
      brand: 'Eskimo',
      category: 'e-hauler',
      scope: SCOPE.PRIMARY,
      launchPrice: 89.99,
      affiliateUrl: 'https://at.fish/E-HaulerFldngCargoRack',
      specs: [
        'adjustable mounting for most sled widths',
        'approximately 20-40 inches across outer sled lip',
        'steel construction',
        'folds flat',
        'integrated auger securing strap',
        'creates storage space below long gear',
      ],
      description:
        'The Folding Cargo Rack carries your auger, shelter or rod bag above the sled so buckets, electronics and other gear can stay below. It folds down against the sled walls when you need to store or transport the sled.',
      defaultPlacement: 'ehauler_walkout',
    },
    {
      id: 'e-hauler-xl-sled',
      name: 'E-Hauler XL Sled',
      brand: 'Eskimo',
      category: 'e-hauler',
      scope: SCOPE.PRIMARY,
      launchPrice: 149.99,
      affiliateUrl: 'https://at.fish/E-HaulerXLSled',
      specs: [
        '64" L x 36" W x 12" H',
        'high-density polymer',
        'tow rope included',
        'compatible with tow-hitch accessories',
      ],
      description:
        'The E-Hauler XL Sled provides a large 64-by-36-inch tub for bigger loads and is built for both walking and machine towing.',
      defaultPlacement: 'ehauler_towing',
    },
    {
      id: 'e-hauler-pulk-system',
      name: 'E-Hauler Pulk System',
      brand: 'Eskimo',
      category: 'e-hauler',
      scope: SCOPE.PRIMARY,
      launchPrice: 79.99,
      affiliateUrl: 'https://at.fish/E-HaulerPulkSystem',
      specs: [
        'padded waist harness',
        'two rigid fiberglass poles',
        'four 40-inch pole sections build two 80-inch poles',
        'included hitch mounting plate',
        'breaks down for transportation',
      ],
      description:
        'The Pulk System is designed for anglers walking gear onto the ice. Instead of pulling a loose rope with your arms, the waist harness and rigid poles distribute the load across your body, keep your hands free and prevent the sled from sliding into your legs on downhill sections.',
      defaultPlacement: 'ehauler_walkout',
    },
    {
      id: 'e-hub-waste-bag-holder',
      name: 'E-Hub Waste Bag Holder',
      brand: 'Eskimo',
      category: 'e-hub',
      scope: SCOPE.PRIMARY,
      launchPrice: 24.99,
      affiliateUrl: 'https://at.fish/EHubWasteBagHolder',
      description:
        'A simple E-Hub-mounted frame that holds common plastic shopping bags open as a convenient trash receptacle inside the shelter.',
      defaultPlacement: 'ehub',
    },
    {
      id: 'e-hub-triple-rod-holder',
      name: 'E-Hub Triple Rod Holder',
      brand: 'Eskimo',
      category: 'e-hub',
      scope: SCOPE.PRIMARY,
      launchPrice: 39.99,
      affiliateUrl: 'https://at.fish/EHubTripleRodHolder',
      description:
        'The new Triple Rod Holder holds three rods from a single E-Hub connection, includes the standard mounting base and pivots for either fishing or storage.',
      defaultPlacement: 'ehub',
    },
    {
      id: 'flex-jacket',
      name: 'Flex Jacket',
      brand: 'Eskimo',
      category: 'apparel',
      scope: SCOPE.PRIMARY,
      launchPrice: 249.99,
      affiliateUrl: 'https://at.fish/EskimoFlexJacket',
      defaultPlacement: 'flex_suit',
    },
    {
      id: 'flex-bibs',
      name: 'Flex Bibs',
      brand: 'Eskimo',
      category: 'apparel',
      scope: SCOPE.PRIMARY,
      launchPrice: 249.99,
      affiliateUrl: 'https://at.fish/EskimoFlexBibs',
      extraFeatures: [
        'reinforced built-in knee pads',
        'adjustable waist',
        'full leg access / mobility-focused construction',
      ],
      defaultPlacement: 'flex_suit',
    },
    {
      id: 'fatfish-450i',
      name: 'FatFish 450i',
      brand: 'Eskimo',
      category: 'shelter',
      scope: SCOPE.PRIMARY,
      launchPrice: 549.99,
      affiliateUrl: 'https://at.fish/EskimoFatfish450i',
      comparison: {
        capacity: '4-5 person',
        fishableArea: '75 sq. ft.',
        weight: '52.5 lb.',
        packLength: '4\'10"',
        fabric: 'IQ Insulated',
        doors: '1 No-Trip Door + 1 D-Door',
        windows: '7',
        gearNets: '2',
        bestFit: 'Best overall day-shack value',
      },
      outbreakFacts: ['52.5 lb.', '75 sq. ft.', 'IQ Insulated fabric'],
      description:
        'The FatFish 450i is the standout day-shelter value in the new lineup. For only a small increase in price and weight over the QuickFish 4HD, it adds substantially more fishable area, larger windows, overhead storage and a shorter pack length.',
      defaultPlacement: 'product_detail',
    },
    {
      id: 'fatfish-650i',
      name: 'FatFish 650i',
      brand: 'Eskimo',
      category: 'shelter',
      scope: SCOPE.PRIMARY,
      launchPrice: 699.99,
      affiliateUrl: 'https://at.fish/EskimoFatfish650i',
      comparison: {
        capacity: '5-7 person',
        fishableArea: '94 sq. ft.',
        weight: '63.5 lb.',
        packLength: '5\'6"',
        fabric: 'IQ Insulated',
        doors: '1 No-Trip Door + 1 D-Door',
        windows: '9',
        gearNets: '3',
        bestFit: 'Bigger groups',
      },
      outbreakFacts: ['63.5 lb.', '94 sq. ft.', 'IQ Insulated fabric'],
      description:
        'The FatFish 650i scales the same concept to 94 square feet and a 5-7 person rating. It keeps the IQ insulated fabric, full No-Trip Door, rear D-door and Packdown-style geometry while adding more windows, storage and ventilation for the larger shelter.',
      defaultPlacement: 'product_detail',
    },
    {
      id: 'fatfish-850i',
      name: 'FatFish 850i',
      brand: 'Eskimo',
      category: 'shelter',
      scope: SCOPE.PRIMARY,
      launchPrice: 799.99,
      affiliateUrl: 'https://at.fish/EskimoFatfish850i',
      comparison: {
        capacity: '7-9 person',
        fishableArea: '114 sq. ft.',
        weight: '73.5 lb.',
        packLength: '4\'9"',
        fabric: 'IQ Insulated',
        doors: '1 No-Trip Door + 1 D-Door',
        windows: '11',
        gearNets: '4',
        bestFit: 'Large groups / basecamp',
      },
      outbreakFacts: [
        '73.5 lb.',
        '114 sq. ft.',
        '1 No-Trip Door + 1 D-Door',
        'IQ Insulated fabric',
      ],
      description:
        'The 850i is the largest FatFish in the new lineup. It provides 114 square feet, a 7-9 person rating, 11 windows and four overhead gear nets while still packing down to only 4\'9". This is the FatFish that makes the most sense for large groups and ice-camping-style setups.',
      defaultPlacement: 'product_detail',
    },
    {
      id: 'quickfish-4hd',
      name: 'QuickFish 4HD',
      brand: 'Eskimo',
      category: 'shelter',
      scope: SCOPE.PRIMARY,
      launchPrice: 499.99,
      affiliateUrl: 'https://at.fish/EskimoQuickfish4HD',
      comparison: {
        capacity: '4 person',
        fishableArea: '60 sq. ft.',
        weight: '50 lb.',
        packLength: '5\'6"',
        fabric: 'IQ Insulated',
        doors: '1 No-Trip Door + 1 D-Door',
        windows: '4',
        gearNets: '0',
        bestFit: 'Portable day shelter',
      },
      description:
        'The QuickFish 4HD adds a middle size to Eskimo\'s HD lineup. You get 60 square feet of fishable area, insulated IQ fabric, a gray interior, a full No-Trip Door plus rear D-door, and a 50-pound packed weight. It is the lighter, simpler choice if portability matters more than maximizing interior room.',
      defaultPlacement: 'product_detail',
    },
    {
      id: 'standard-tow-hitch',
      name: 'Standard Tow Hitch',
      brand: 'Eskimo',
      category: 'e-hauler',
      scope: SCOPE.PRIMARY,
      launchPrice: 69.99,
      affiliateUrl: 'https://at.fish/EskimoStandardTowHitch',
      specs: [
        'rigid steel frame',
        'mounts to front of sled',
        'fits most sled widths',
        'clevis and pin machine attachment',
        'removable via snap pin',
      ],
      description:
        'The Standard Tow Hitch is the machine-towing option. Its rigid steel design keeps a sled tracking behind a snowmobile or ATV and fits most sled widths.',
      defaultPlacement: 'ehauler_towing',
    },
    {
      id: 'aluminum-xl-tripod-chair',
      name: 'Aluminum XL Tripod Chair',
      brand: 'Eskimo',
      category: 'accessory',
      scope: SCOPE.PRIMARY,
      launchPrice: 69.99,
      affiliateUrl: 'https://at.fish/EskimoAlmXLTripodChair',
      specs: [
        'aluminum frame',
        '4 lb.',
        '400 lb. capacity',
        'larger XL seat',
        'integrated carry strap',
      ],
      description:
        'A larger tripod-style folding chair that weighs only four pounds while carrying a 400-pound rated capacity.',
      defaultPlacement: 'product_detail',
    },
    {
      id: 'outpost-wool-hoodie',
      name: 'Outpost Wool Hoodie',
      brand: 'Eskimo',
      category: 'apparel',
      scope: SCOPE.PRIMARY,
      launchPrice: 129.99,
      affiliateUrl: 'https://at.fish/EskimoOutpostHoodie',
      description:
        'The Outpost is a premium warm midlayer made from 73% polyester, 25% wool and 2% spandex smooth-face fleece, with a zippered kangaroo-style handwarming pocket.',
      defaultPlacement: 'apparel',
    },
    {
      id: 'traverse-wool-jacket',
      name: 'Traverse Wool Jacket',
      brand: 'Eskimo',
      category: 'apparel',
      scope: SCOPE.PRIMARY,
      launchPrice: 179.99,
      affiliateUrl: 'https://at.fish/EskimoTraverseJacket',
      description:
        "The Traverse Wool Jacket combines a 60/40 polyester-wool outer, 80gm 3M Thinsulate insulation, a 5K/5K waterproof/breathable membrane and DWR treatment. Eskimo's technical specifications list it as not fully waterproof because the seams are not taped, so think of it as a warm, weather-resistant jacket rather than a rain shell.",
      defaultPlacement: 'apparel',
    },
    {
      id: 'flag-hoodie',
      name: 'Flag Hoodie',
      brand: 'Eskimo',
      category: 'apparel',
      scope: SCOPE.PRIMARY,
      launchPrice: 69.99,
      affiliateUrl: 'https://at.fish/EskimoFlagHoodie',
      defaultPlacement: 'apparel',
    },
    {
      id: 'abyss-hoodie',
      name: 'Abyss Hoodie',
      brand: 'Eskimo',
      category: 'apparel',
      scope: SCOPE.PRIMARY,
      launchPrice: 69.99,
      affiliateUrl: 'https://at.fish/EskimoAbyssHoodie',
      defaultPlacement: 'apparel',
    },
    {
      id: 'dipped-gloves',
      name: 'Dipped Gloves',
      brand: 'Eskimo',
      category: 'apparel',
      scope: SCOPE.PRIMARY,
      launchPrice: 14.99,
      affiliateUrl: 'https://at.fish/EskimoDippedGloves',
      description:
        'A close-fitting cold-weather utility glove with a fully waterproof nitrile-dipped coating to the wrist, textured grip, thermal lining and 4-way stretch.',
      defaultPlacement: 'apparel',
    },
    {
      id: 'outbreak-450xdp',
      name: 'Outbreak 450XDP',
      brand: 'Eskimo',
      category: 'shelter',
      scope: SCOPE.SUPPORTING,
      launchPrice: 629.99,
      affiliateUrl: 'https://at.fish/EskimoOutbreak450XDP',
      outbreakFacts: [
        '57 lb.',
        '75 sq. ft.',
        'StormShield Insulated fabric',
        'heat-source duct ports',
        'propane-line port',
      ],
      defaultPlacement: 'outbreak_comparison',
    },
    {
      id: 'outbreak-650xdp',
      name: 'Outbreak 650XDP',
      brand: 'Eskimo',
      category: 'shelter',
      scope: SCOPE.SUPPORTING,
      launchPrice: 779.99,
      affiliateUrl: 'https://at.fish/EskimoOutbreak650XDP',
      outbreakFacts: [
        '70 lb.',
        '94 sq. ft.',
        'StormShield Insulated fabric',
        'additional premium heating/ventilation features',
      ],
      defaultPlacement: 'outbreak_comparison',
    },
    {
      id: 'outbreak-850xdp',
      name: 'Outbreak 850XDP',
      brand: 'Eskimo',
      category: 'shelter',
      scope: SCOPE.SUPPORTING,
      launchPrice: 899.99,
      affiliateUrl: 'https://at.fish/EskimoOutbreak850XDP',
      outbreakFacts: [
        '78 lb.',
        '120 sq. ft.',
        '2 No-Trip Doors',
        'StormShield Insulated fabric',
      ],
      defaultPlacement: 'outbreak_comparison',
    },
    {
      id: 'e-hub-triple-mount',
      name: 'E-Hub Triple Mount',
      brand: 'Eskimo',
      category: 'e-hub',
      scope: SCOPE.SUPPORTING,
      launchPrice: null,
      affiliateUrl: 'https://at.fish/EskimoE-HubTripleMount',
      isNewForLaunch: false,
      defaultPlacement: 'ehub_cross_sell',
    },
  ],
});
